import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const router = new Router({
  mode: 'history',
  base: `/`,
  routes: [
    {
      path: '/es-es/vende-con-wegow',
      name: 'promotores'
    },
    // {
    //   path: '/',
    //   name:
    //     process.env.VUE_APP_COMPANY === 'true'
    //       ? 'companyDetail'
    //       : 'eventDetail',
    //   component:
    //     process.env.VUE_APP_COMPANY === 'true'
    //       ? loadView('company-detail/CompanyDetail')
    //       : loadView('event-detail/EventDetail')
    // },
  ]
})

export default router
